(function(NS, undefined) {

  let menuOpen = false;
  let menuTimer = null;

  if (document.readyState != "loading") {
    init();
  } else {
    document.addEventListener("DOMContentLoaded", init);
  }

  function init() {
    setupOptionSelector();
    navInit();
    accordionInit();
    bannerVideoInit();
    validationInit();
    initSwiper();
  }

  /*
  * HISTORY STATE
  * Check if window.history is supported
  */
  function historyState() {
    return window.history && window.history.replaceState;
  };


  /*
  * GET URL PARAMETER
  * Checks for url parameter called `name`.
  */
  function getParam(name) {
    if ('URLSearchParams' in window) {
      var params = new URLSearchParams(window.location.search);
      return params.get(name);
    } else {
      // Polyfill for IE11
      var params = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
      if (params == null) {
        return null;
      } else {
        return decodeURI(params[1]) || 0;
      }
    }
  }
  NS.getParam = getParam();

  /*
  * FORMAT MONEY
  * Formats the passed value as money with currency symbol.
  * Referenced from https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
  */
  var Shopify = Shopify || {};
  Shopify.money_format = "${{amount}}";
  Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) { return 0; }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };


  /*
  * OPTION SELECTOR
  * Works the variant option dropdowns used on the
  * product page template.
  */
  function setupOptionSelector() {
    var variant;
    var options = [];
    options[1] = null;
    options[2] = null;
    options[3] = null;

    var variantOptions = document.querySelectorAll(".js--variant-option");
    variantOptions.forEach(function(el) {
      el.addEventListener("change", function(event) {
        // Disable non-existent variant options.
        checkVariants();

        // Set the chosen options.
        variantOptions.forEach(function(opt) {
          if (opt.tagName.toLowerCase() == 'input' && opt.checked == true) {
            var optionName = opt.getAttribute("name");
            var optionPos = parseInt(optionName.replace("option", ""));
            var optionValue = opt.value;
            options[optionPos] = optionValue;
          }
        });

        // Loop through the variants and get the selected one.
        variants.filter(function(v) {
          if (v.option1 == options[1] && v.option2 == options[2] && v.option3 == options[3]) {
            variant = v;

            // Update variant id and prices
            document.querySelector("input#js--variant-id").value = v.id;
            // The following is used for the "purchase together" feature.
            document.querySelectorAll('input[type="checkbox"].js--variant-id').forEach(function(el) {
              el.value = v.id;
              el.setAttribute('data-price', v.price);
              if (v.available == true) {
                el.checked = true;
                el.disabled = false;
              } else {
                el.checked = false;
                el.disabled = true;
              }
            });
            document.querySelectorAll(".js--variant-price").forEach(function(el) {
              // OLD:
              // el.innerHTML = Shopify.formatMoney(v.price);
              // NEW: Include donation amount in displayed price
              el.innerHTML = Shopify.formatMoney(v.price + (v.option1.substring(10) * 100));
            });

            // For giving angel donation subtotal
            document.querySelectorAll(".js--donation-subtotal").forEach(function(el) {
              // OLD (donation included in angel variant price):
              // let basePrice = document.querySelector('[data-base-price]').dataset.basePrice;
              // let messagePrice = document.querySelector('[data-message-price]').dataset.messagePrice;
              // let messageSubtotal = v.option2 == 'Personalised message' ? messagePrice : 0;
              // el.innerHTML = Shopify.formatMoney(v.price - basePrice - messageSubtotal).replace('.00','');
              // NEW (donation is separate product):
              el.innerHTML = Shopify.formatMoney(v.option1.substring(10) * 100).replace('.00','');
            });
            let messageSubtotalEl = document.querySelector(".js--message-subtotal");
            if (messageSubtotalEl) {
              messageSubtotalEl.classList.toggle('none', v.option2 == 'No message');
            }

            if (v.compare_at_price > v.price) {
              document.querySelectorAll(".js--variant-compareatprice").forEach(function(el) {
                el.innerText = Shopify.formatMoney(v.compare_at_price);
              });
            } else {
              document.querySelectorAll(".js--variant-compareatprice").forEach(function(el) {
                el.innerText = "";
              });
            }

            // Update SKU
            document.querySelectorAll('.js--variant-sku').forEach(function(el) {
              el.innerText = variant.sku;
            });

            // Disable the buy button if product is unavailable
            if (v.available === false) {
              document.querySelector("#js--addtocart").disabled = true;
              document.querySelector("#js--addtocart").innerText = "Unavailable";
            } else {
              document.querySelector("#js--addtocart").disabled = false;
              document.querySelector("#js--addtocart").innerText = "Add to cart";
            }

            // Update image
            // var imageId = (v.featured_image != null) ? v.featured_image.id : default_image;
            // var imageIndex = document
            //   .querySelector('.product-image-item[data-imageid="' + imageId + '"]')
            //   .getAttribute("data-index");
            // var sliderContainer = document.querySelector(".product-images-component");
            // goToImage(imageIndex, sliderContainer);

            // Append the variant ID as a url parameter
            if (v != undefined) {
              if (historyState()) {
                window.history.replaceState({}, document.title, "?variant=" + v.id);
              }
            }
          }
        });
      });
    });

    // Personalised message option
    // The option variants are visually hidden. A toggle switch reveals a line item property textarea
    // and also toggles the variant.
    let personalisedMessageOptions = document.querySelector('.personalised-message-option'); // variant option
    let personalisedMessagetoggle = document.querySelector('.js--personalised-message-toggle'); // toggle switch
    if (personalisedMessageOptions && personalisedMessagetoggle) {
      personalisedMessagetoggle.addEventListener("change", function(event) {
        personalisedMessageOptions.querySelector('input[value="Personalised message"]').checked = personalisedMessagetoggle.checked;
        personalisedMessageOptions.querySelector('input[value="No message"]').checked = !personalisedMessagetoggle.checked;
        // and manually dispatch a change event on the checkbox to update subtotals
        let change = new Event('change');
        let checked = personalisedMessageOptions.querySelector('input:checked');
        checked.dispatchEvent(change);
      });
    }

    // Charity option - set hidden ABN field when charity is selected
    let charitySelect = document.querySelector('#charity');
    let charityAbnInput = document.querySelector('#charity-abn');
    if (charitySelect && charityAbnInput) {
      charitySelect.addEventListener("change", function(event) {
        let selectedOption = charitySelect.options[charitySelect.selectedIndex];
        let abn = selectedOption.getAttribute('data-abn') || '';
        charityAbnInput.value = abn;
      });
    }
  };

  /*
  * CHECK VARIANT EXISTS
  * This checks if the variant actually exists - e.g you may have small, medium,
  * and large in blue and black, but blue/medium is not a variant. Disables the
  * related inputs.
  */
  function checkVariants() {
    let $this = event.target;
    if ($this !== undefined) {
      let availableVariants = new Set();
      variants.filter(function(variant, k) {
        if (variant[$this.name] == $this.value) {
          availableVariants.add(variant);
        }
      });

      // Loop through the array above to create an array containing available
      // option values.
      let optionGroups = {};
      availableVariants.forEach(function(variant) {
        let options = Object.entries(variant);
        for (const [key, value] of options) {
          if (value != null) {
            if (optionGroups[key] == undefined) {
              optionGroups[key] = [];
            }
            if (optionGroups[key].includes(value) == false) {
              optionGroups[key].push(value);
            }
          }
        }
      });

      // Then, loop through each input and check if its value is in the optionGroups
      // array created above, ignoring the clicked option group.
      document.querySelectorAll(".js--variant-option").forEach(function(input) {
        if (input.name != $this.name) {
          if (optionGroups[input.name].includes(input.value) == false) {
            input.disabled = true;
            input.checked = false;
          } else {
            input.disabled = false;
          }
        }
      });
    }

    // Check a valid option is selected for each group.
    document.querySelectorAll(".js--variant-options").forEach(function(group) {
      let firstAvailable = null;
      let checkedOptions = group.querySelectorAll('.js--variant-option:checked').length;
      if (checkedOptions == 0) {
        firstAvailable = group.querySelectorAll(".js--variant-option:not(:disabled)")[0];
      }
      if (firstAvailable != null) {
        firstAvailable.checked = true;
      }
    });
  }

  /*
  * TOGGLE MOBILE NAV
  * Open/close main nav on mobile. This just applies a class
  * and the rest is done in CSS.
  */
  function navInit() {
    // Nav menu events
    document.querySelector('.menu-toggle').addEventListener('mousedown', function() {
      clearTimeout(menuTimer);
      document.querySelector('html').classList.remove('menu-open','menu-closing');
      if (!menuOpen) {
        menuOpen = true;
        document.querySelector('html').classList.add('menu-open');
      } else {
        menuOpen = false;
        document.querySelector('html').classList.add('menu-closing');
        menuTimer = window.setTimeout(function() {
          document.querySelector('html').classList.remove('menu-closing');
        }, 800);
      }
    });

    // Homepage navbar logo animation
    // Create a new IntersectionObserver object
    let observer = new IntersectionObserver(function (entries, observer) {
      for (let entry of entries) {
        // .header-section is sticky when its top is -1px, so we can detect
        // that it is outside the viewport
        entry.target.classList.toggle('stuck', entry.intersectionRatio < 1);
      }
    }, { rootMargin: "50px 0px 0px 0px", threshold: [1] });

    // Interior page nav scroll detection
    // Header is always stuck, so we use scroll detection instead
    if (!document.querySelector('body').classList.contains('home')) {
      window.addEventListener('scroll', function (event) {
        if (window.pageYOffset > 5) {
          document.querySelector('.header-section').classList.add('stuck');
        } else {
          document.querySelector('.header-section').classList.remove('stuck');
        }
      }, false);
    }

    // The element to observe
    let header = document.querySelector('.header-section');
    observer.observe(header);
  }

  // Accordions
  function accordionInit() {
		const accordionBtns = document.querySelectorAll('.accordion-btn');
		accordionBtns.forEach((el, index) => {
			el.addEventListener('click', function(event) {
        let accordion = el.closest('.accordion');
        accordion.classList.toggle('open');	
			});
		});
  }

  function bannerVideoInit() {
    const bannerVideos = document.querySelectorAll('.banner video');
    // We manually loop videos so that we can restart the overlay animation
    // when the video ends.
    bannerVideos.forEach((el, index) => {
      el.addEventListener('ended', function () {
        this.play();
        let overlay = el.closest('.banner').querySelector('.banner__overlay .fade-out')
        if (overlay) {
          // Reset the animation so it can be played again
          overlay.style.animation = 'none';
          overlay.offsetHeight; // trigger reflow
          overlay.style.animation = null; 
        }
        // let button = el.closest('.banner').querySelector('.banner__button')
        // if (button) {
        //   // Reset the animation so it can be played again
        //   button.style.animation = 'none';
        //   button.offsetHeight; // trigger reflow
        //   button.style.animation = null; 
        // }
      });
		});
  }

  // Our product form has HTML validation for required fields, but if the error is off screen
  // the user may not see it. This function displays a message to the user.
  function validationInit() {
    document.querySelectorAll('#js--addtocart').forEach((button) => {
      button.addEventListener('click',(event)=>{
        for (const el of button.closest('form[action="/cart/add"]').querySelectorAll("[required]")) {
          const msg = document.querySelector('.add-to-cart-validation-message');
          msg.classList.toggle('none', el.reportValidity());
        }
      });
    });
  }

  function initSwiper() {
    const swiper = new Swiper('.swiper', {
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      speed: 800,
      loop: true,
      slidesPerView: 2,
      spaceBetween: 10,
      slidesPerGroup: 2,
      simulateTouch: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
					// when viewport width is >= X
					601: {
						slidesPerView: 4,
						spaceBetween: 20,
						slidesPerGroup: 4
					}
				}
    });
  }

}(window.fnapp = window.fnapp || {}));